import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { ContactService } from "../services/contact-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { ContractService } from "../services/contract-service";
import { NotifyService } from "../services/notify-service";

export function RLCreateAndAssociateHierarchicalRecords() {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/create-and-associate-hierarchical-records.html"),
        controllerAs: "caahrVM",
        controller: CreateAndAssociateHierarchicalRecordsController,
        bindToController: true,
        scope: {
            entityID: "=entityId",
            successUrl: "=?",
            cancelUrl: "=?",
            originalEntityID: "=originalEntityId"
        }
    };
    return directive;
}



export class CreateAndAssociateHierarchicalRecordsController {
    static $inject = ["$scope", "$window", "$filter", "$q", "notifyService", "contactService", "entityService", "eventService", "contractService"];

    entityID: string;
    originalEntityID: string;
    charTypeID: number;
    templateID: number;
    childCharTypeID: number;
    childTemplates: Models.ITemplateHierarchy[];
    showTemplateHierarchy: boolean;
    editMode: boolean;
    showJobProgressStatus: boolean;
    showProgressSpinner: boolean;
    jobId: string;
    jobTitle: string;
    progressStatus: string;
    successUrl: string;
    cancelUrl: string;

    constructor(
        private $scope: ng.IScope, private $window: ng.IWindowService, private $filter: ng.IFilterService, private $q: ng.IQService, private notifyService: NotifyService,
        private contactService: ContactService, private entityService: EntityService, private eventService: EventService, private contractService: ContractService) {

        this.templateID = 0;
        this.childTemplates = [];
        this.showTemplateHierarchy = true;
        this.showJobProgressStatus = false;
        this.editMode = true;


        $scope.$watchCollection(() => [this.entityID],
            (newValue, oldValue) => {
                if (this.entityID != null) {
                    this.Init(this.entityID);
                }
            });

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue != oldValue && newValue == "Done") {
                if (this.originalEntityID != "-1") {
                    var originalCharTypeID = Utils.IdBuilder.splitEntityID(this.originalEntityID).charTypeID;
                    if (originalCharTypeID != Consts.CharTypeIDs.property) {
                        this.entityService.refreshRelsForCatalogItems(this.originalEntityID, this.entityID)
                            .then(() => {
                                this.showJobProgressStatus = false;
                                this.progressStatus = null;
                                this.notifyService.notifySuccess("Create Hierachical Records successful.");
                                var successUrl = this.getSuccessURL();
                                this.$window.location.assign(successUrl);
                            });
                    }
                    else {
                        this.showJobProgressStatus = false;
                        this.progressStatus = null;
                        this.notifyService.notifySuccess("Create Hierachical Records successful.");
                        var successUrl = this.getSuccessURL();
                        this.$window.location.assign(successUrl);
                    }
                }
                else {
                    this.showJobProgressStatus = false;
                    this.progressStatus = null;
                    this.notifyService.notifySuccess("Create Hierachical Records successful.");
                    var successUrl = this.getSuccessURL();
                    this.$window.location.assign(successUrl);
                }
            }
        });
    }

    getSuccessURL() {
        var successURL = this.successUrl;
        if (this.originalEntityID != "-1") {
            successURL = this.successUrl.replace("-1", Utils.IdBuilder.splitEntityID(this.originalEntityID).recID.toString());
        }
        else {
            successURL = this.successUrl.replace("-1", Utils.IdBuilder.splitEntityID(this.entityID).recID.toString());
        }
        return successURL;
    }

    getCancelURL() {
        var cancelURL = this.cancelUrl;
        if (this.originalEntityID != "-1") {
            cancelURL = this.cancelUrl.replace("-1", Utils.IdBuilder.splitEntityID(this.originalEntityID).recID.toString());
        }
        else {
            cancelURL = this.cancelUrl.replace("-1", Utils.IdBuilder.splitEntityID(this.entityID).recID.toString());
        }
        return cancelURL;
    }

    Init(entityID: string) {
        this.notifyService.startProgress();
        this.charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;

        this.entityService.getEntity(this.entityID)
            .then((result) => {
                this.templateID = result.record.templateID;
                var parentTemplates: number[] = [this.templateID];
                this.entityService.getAssociatedTemplatesForTemplate(this.charTypeID, this.templateID, this.charTypeID).
                    then((result) => {
                        if (result.length == 0) {
                            //no child templates available, continue to details page of new asset
                            var successURL = this.getSuccessURL();
                            this.$window.location.assign(successURL);
                        }
                        result.forEach(t => {
                            var newTemp: Models.ITemplateHierarchy = { directParentTemplates: parentTemplates, templateID: t.templateID, templateLabel: t.templateName, childTemplates: null, level: 1, numberOfRecords: 0 };
                            this.childTemplates.push(newTemp);
                        });
                    })
                    .finally(() => {
                        this.notifyService.endProgress();
                    });
            });
    }

    CreateAndAssociate() {
        this.notifyService.startProgress();
        this.entityService.createHierachicalRecords(this.entityID, this.childTemplates)
            .then((result) => {
                this.jobId = result.jobID;
                this.jobTitle = result.jobTitle;
                this.showTemplateHierarchy = false;
                this.showJobProgressStatus = true;
                this.notifyService.endProgress();
            });
    }

    Cancel() {
        var cancelURL = this.getCancelURL();
        this.$window.location.assign(cancelURL);
    }

}
